"use client";
import React, { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { Uploader } from "@/lib/upload/multipart-upload";
import { cn } from "@/lib/utils";

export const UploadProgress = ({
  uploader,
  uploadStatus,
  value,
  className,
}: {
  uploader: React.RefObject<Uploader | null>;
  uploadStatus: string;
  value?: number;
  className?: string;
}) => {
  const [uploadProgress, setUploadProgress] = useState(value ?? 1);

  useEffect(() => {
    if (value !== undefined) setUploadProgress(value);
  }, [value]);

  useEffect(() => {
    if (uploader.current) {
      uploader.current.onProgressFn = (progress) => {
        setUploadProgress(progress.percentage);
      };
    }
  }, [uploader.current]);

  return (
    <Progress
      value={uploadProgress}
      className={cn(
        {
          "w-full invisible": true,
          visible: uploadStatus === "LOADING" || value !== undefined,
        },
        className
      )}
    />
  );
};
